import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../common/Table/table";
import AddUpdatePhlebotomist from "./AddUpdatePhlebotomist";

import {
  createPhlebotomist,
  getPhlebotomist,
  updatePhlebotomist,
} from "../../../store/slices/phlebotomistSlice";

const Phlebotomist = () => {
  const dispatch = useDispatch();
  const [modalAction, setModalAction] = useState("create");
  const { token } = useSelector((state) => state.auth);

  const { clinicInfo } = useSelector((state) => state.clinic);

  const clinicId = clinicInfo?.[0]?.clinicId;

  const { phlebotomist, loading } = useSelector((state) => state.phlebotomist);

  const [showModal, setModalVisible] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);

  const initialState = {
    id: "",
    name: "",
    mobileNo: "",
    email: "",
    password: "",
    status: "Active",
  };
  const [formData, setFormData] = useState(initialState);

  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
  });

  useEffect(() => {
    if (clinicId && token) {
      dispatch(
        getPhlebotomist({
          clinicId,
          token,
        }),
      );
    }
  }, [dispatch, clinicId, token]);

  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Mobile Number", key: "mobileNo" },
    { title: "Email", key: "email" },
    { title: "Status", key: "status" },
  ];

  const handleModal = (action, data = null) => {
    setModalAction(action);

    if (action === "create") {
      setFormData(initialState);
    }

    if (action === "edit" && data) {
      setFormData({
        id: data.id,
        name: data.name,
        mobileNo: data.mobileNo,
        email: data.email,
        password: "",
        status: data.status,
      });
    }

    setModalVisible(true);
  };
  const handleEdit = (data) => {
    handleModal("edit", data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSavePhlebotomist = async (e) => {
    e.preventDefault();

    const { name, email, phNumber } = inputError;

    if (name || email || phNumber) {
      return;
    }

    try {
      if (modalAction === "create") {
        await dispatch(
          createPhlebotomist({
            formData: {
              clinicId,
              name: formData.name,
              mobileNo: formData.mobileNo,
              email: formData.email,
              password: formData.password,
            },
            token,
          }),
        );
      } else {
        await dispatch(
          updatePhlebotomist({
            id: formData.id,
            mobileNo: formData.mobileNo,
            email: formData.email,
            status: formData.status,
            token,
          }),
        );
      }

      await dispatch(
        getPhlebotomist({
          clinicId,
          token,
        }),
      );

      setModalVisible(false);

      setFormData(initialState);
    } catch (error) {
      console.log(error);
    }
  };
  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getPhlebotomist({
        clinicId,
        token,
      }),
    );
    setShowGlobalViewModal(true);
  };

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          Array.isArray(phlebotomist)
            ? phlebotomist.map((item) => ({
                id: item._id,
                name: item.userId?.name,
                mobileNo: item.mobileNo,
                email: item.email,
                status: item.status,
              }))
            : []
        }
        addModal={() => handleModal("create")}
        handleEdit={handleEdit}
        handleAddBtn={true}
        isLoading={loading}
      />

      <AddUpdatePhlebotomist
        showModal={showModal}
        setModalVisible={setModalVisible}
        formData={formData}
        handleChange={handleChange}
        handleCreatePhlebotomist={handleSavePhlebotomist}
        modalAction={modalAction}
        setInputError={setInputError}
      />
    </div>
  );
};

export default Phlebotomist;
